/**Dependencies */
import React, { useEffect, useState } from "react";

/**Styles */
import "../styles/CheckOutCart.scss";

/**Images */
import iconCart from "../images/iconCart.png";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

export const CheckOutCart = ({ arrDatos, setAlert, showAlert, setAlertMessage }) => {
  const [totalReserva, setTotalReserva] = useState(0);
  const [message, setMessage] = useState("")
  const navigate = useNavigate();
  useEffect(() => {
    const hospedaje = arrDatos?.hospedaje;
    let sumaReservas = 0;

   if (hospedaje?.length > 0) {
      sumaReservas = hospedaje?.length;
    }
    setTotalReserva(sumaReservas);
    if(showAlert) {
      if (totalReserva > 0) {
        setMessage(setAlertMessage);
        setAlert(false);
  
        const timeoutId = setTimeout(() => {
          setMessage("");
        }, 1500);
  
        return () => clearTimeout(timeoutId);
      }
    }

  }, [arrDatos, totalReserva]);

  return (
    <div className="float_cart">
      {message && (
        <div className="alert_cart">
          <span>
          {message}
          </span>
        </div>
      )}
      <div>
      <span className="count_cart">{totalReserva}</span>
      <Button onClick={() => [window.scrollTo(0, 0), navigate("/preventa")]} disabled={totalReserva > 0 ? false : true} className="bg-transparent border-0">
        <img src={iconCart} alt="" className="cart_icon" />
      </Button>
      </div>
    </div>
  );
};
